(function () {
  /* store-specific: Instagram Business Account ID (space.souvenir.shop) */
  var IG_USER_ID = '17841443853793279';
  var API_BASE   = 'https://graph.facebook.com/v5.0/' + IG_USER_ID + '/media';
  var FIELDS     = 'id,media_type,media_url,thumbnail_url,permalink';

  function fetchMedia(token, limit, onSuccess, onError) {
    fetch(API_BASE + '?fields=' + FIELDS + '&limit=' + limit + '&access_token=' + token)
      .then(function (r) { return r.json(); })
      .then(function (data) { onSuccess(data && data.data ? data.data : []); })
      .catch(onError);
  }

  // マーキーモード
  document.querySelectorAll('[data-instagram-marquee]').forEach(function (track) {
    var token = track.dataset.igToken;
    if (!token) return;
    fetchMedia(token, 15, function (items) {
      if (!items.length) return;
      [false, true].forEach(function (isDupe) {
        items.forEach(function (item) {
          var imgUrl = item.media_type === 'VIDEO' ? item.thumbnail_url : item.media_url;
          if (!imgUrl) return;
          var a       = document.createElement('a');
          a.href      = item.permalink;
          a.target    = '_blank';
          a.rel       = 'noopener noreferrer';
          a.className = 'about-instagram__item';
          if (isDupe) { a.setAttribute('aria-hidden', 'true'); a.tabIndex = -1; }
          var img     = document.createElement('img');
          img.src     = imgUrl;
          img.alt     = '';
          img.loading = 'lazy';
          img.width   = 240;
          img.height  = 300;
          a.appendChild(img);
          track.appendChild(a);
        });
      });
    }, function () {
      var s = track.closest('.about-instagram');
      if (s) s.style.display = 'none';
    });
  });

  // グリッドモード
  document.querySelectorAll('[data-instagram-grid]').forEach(function (grid) {
    var token = grid.dataset.igToken;
    var limit = parseInt(grid.dataset.igLimit || '12', 10);
    if (!token) return;
    fetchMedia(token, limit, function (items) {
      if (!items.length) return;
      items.slice(0, limit).forEach(function (item) {
        var imgUrl = item.media_type === 'VIDEO' ? item.thumbnail_url : item.media_url;
        if (!imgUrl) return;
        var a       = document.createElement('a');
        a.href      = item.permalink;
        a.target    = '_blank';
        a.rel       = 'noopener noreferrer';
        a.className = 'instagram-grid__cell';
        var img     = document.createElement('img');
        img.src     = imgUrl;
        img.alt     = '';
        img.loading = 'lazy';
        a.appendChild(img);
        grid.appendChild(a);
      });
    }, function () {
      var s = grid.closest('.ss-instagram');
      if (s) s.style.display = 'none';
    });
  });
})();
